<template>
    <div>
        <div v-if="point.length">
            <point-markers
                v-for="(item, i) in point"
                :key="`${i}`"
                :item="item"
            />
        </div>
        <div v-if="line.length">
            <line-markers
                v-for="(item, i) in line"
                :key="`${i}`"
                :item="item"
            />
        </div>
        <div v-if="multi.length">
            <multi-line-markers
                v-for="(item, i) in multi"
                :key="`${i}`"
                :item="item"
            />
        </div>
        <div v-if="multiPoint.length">
            <multi-point-markers
                v-for="(item, i) in multiPoint"
                :key="`${i}`"
                :item="item"
            />
        </div>
    </div>
</template>

<script>
import PointMarkers from "./components/markers/PointMarkerComponent";
import LineMarkers from "./components/markers/LineStringMarkerComponent";
import MultiLineMarkers from "./components/markers/MultiLineMarkerComponent";
import MultiPointMarkers from "./components/markers/MultiPointMarkerComponent";
import axios from "./axios";
import { mapGetters } from "vuex";

export default {
    name: "ExtraordinaryConditionMarkers",
    components: {
        PointMarkers,
        LineMarkers,
        MultiLineMarkers,
        MultiPointMarkers,
    },

    data() {
        return {
            point: [],
            line: [],
            multi: [],
            multiPoint: [],
        };
    },

    mounted() {
        this.getExtraordinaryConditions();
    },

    methods: {
        async getExtraordinaryConditions(params = {}) {
            let url = this.url ? `${this.url}/extraordinary` : this.url;
            await axios
                .get(url, { params })
                .then((response) => {
                    let { data } = response;

                    if (data && data["Point"] && data["Point"].length > 0) {
                        this.point = data["Point"];
                    } else {
                        this.point = [];
                    }

                    if (
                        data &&
                        data["LineString"] &&
                        data["LineString"].length > 0
                    ) {
                        this.line = data["LineString"];
                    } else {
                        this.line = [];
                    }

                    if (
                        data &&
                        data["MultiLineString"] &&
                        data["MultiLineString"].length > 0
                    ) {
                        this.multi = data["MultiLineString"];
                    } else {
                        this.multi = [];
                    }

                    if (
                        data &&
                        data["MultiPoint"] &&
                        data["MultiPoint"].length > 0
                    ) {
                        this.multiPoint = data["MultiPoint"];
                    } else {
                        this.multiPoint = [];
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                });
        },
    },

    watch: {
        filters(newValue, oldValue) {
            if (newValue && !newValue["highways"]) {
                if (oldValue && oldValue["highways"]) {
                    this.getExtraordinaryConditions();
                }

                return;
            }

            this.getExtraordinaryConditions({ highways: newValue.highways });
        },
    },

    computed: {
        ...mapGetters(["url", "filters"]),
    },
};
</script>
